import React from "react";
import { t } from "ttag";

import type { ShowroomLocationsGalleryBlock as BlockValue } from "@reactivated";

import { CenterFocusedCarousel } from "../CenterFocusedCarousel";
import { ButtonPrimary, Clickable } from "../Clickables";
import { ScheduleVisitModal } from "../ScheduleVisitModal";

import styles from "./index.module.scss";

type LocationData = BlockValue["locations"][number];

export const ShowroomLocation = (props: {
    location: LocationData;
    slug: string;
}) => {
    return (
        <article id={`showroom-${props.slug}`} className={styles.location}>
            {props.location.images.length > 0 && (
                <CenterFocusedCarousel
                    label={t`Showroom gallery`}
                    images={props.location.images}
                />
            )}
            <div className={styles.locationDetails}>
                <h3 className={styles.locationName}>
                    {props.location.display_name}
                </h3>
                <p className={styles.locationAddress}>
                    {props.location.address_summary}
                </p>
                {props.location.phone_national && props.location.phone_e164 && (
                    <Clickable
                        href={`tel:${props.location.phone_e164}`}
                        className={styles.locationContact}
                    >
                        {props.location.phone_national}
                    </Clickable>
                )}
                <div className={styles.locationActions}>
                    {props.location.enable_schedule_visit && (
                        <ScheduleVisitModal />
                    )}
                    {props.location.detail_page_url && (
                        <ButtonPrimary href={props.location.detail_page_url}>
                            {t`Learn More`}
                        </ButtonPrimary>
                    )}
                </div>
            </div>
        </article>
    );
};
